export const UserValidateFields = (values) => {
    let errors = {};

    if (!values.userName?.trim()) {
        errors.userName = "Name field is required.";
    } else if (values?.userName.length < 3 || values?.userName.length > 25) {
        errors.userName = "UserName must be between 3 and 25 characters.";
    }

    if (!values?.email) {
        errors.email = "Email field is required.";
    } else if (!/\S+@\S+\.\S+/.test(values?.email)) {
        errors.email = "Invalid email format. Please provide a valid email address.";
    }


    // Validate password
    if (!values?.password) {
        errors.password = "Password field is required.";
    } else if (values?.password?.length < 8) {
        errors.password = "Password must be at least 8 characters long.";
    } else if (!/[A-Za-z]/.test(values?.password)) {
        errors.password = "Password must contain at least one letter.";
    } else if (!/[0-9]/.test(values?.password)) {
        errors.password = "Password must contain at least one digit.";
    } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(values?.password)) {
        errors.password = "Password must contain at least one special character.";
    }

    // Validate confirmPassword
    if (!values?.confirmPassword) {
        errors.confirmPassword = "Confirm Password field is required.";
    } else if (values?.password !== values?.confirmPassword) {
        errors.confirmPassword = "Passwords do not match.";
    }

    if (!values?.phone_no) {
        errors.phone_no = "Phone number field is required.";
    } else if (!/^\d{10}$/.test(values?.phone_no)) {
        errors.phone_no = "Invalid phone number format. Please provide a valid 10-digit phone number.";
    }


    if (!values.name?.trim()) {
        errors.name = "Template name is required.";
    }

    if (!values.categoryId || values.categoryId.length === 0) {
        errors.categoryId = "Category must be selected.";
    }

    const fileExtensions = {
        pdf: '.ejs',
        docx: '.docx',
        pptx: '.pptx',
        xlsx: '.xlsx'
    };

    // Improved URL validation regex

    const urlRegex = /^(https?:\/\/)([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;


    // Helper function to validate file URLs
    const validateFileUrl = (url, type) => {
        if (url) {
            // if (!urlRegex.test(url)) {
            //     errors[type] = `${type.toUpperCase()} URL must be a valid URL.`;
            // } else
            if (!url.endsWith(fileExtensions[type])) {
                errors[type] = `${type.toUpperCase()} URL must end with ${fileExtensions[type]}`;
            }
        }
    };


    // Validate each file URL
    if (values.pdf) {
        validateFileUrl(values.pdf, 'pdf');
    }
    if (!values.pdf) {
        errors.pdf = "PDF URL is required.";
    }
    // if (!values.docx) {
    //     errors.docx = "DOCX URL is required.";
    // }
    // if (!values.pptx) {
    //     errors.pptx = "PPTX URL is required.";
    // }

    if (values.docx) {
        validateFileUrl(values.docx, 'docx');
    }
    if (values.pptx) {
        validateFileUrl(values.pptx, 'pptx');
    }
    if (values.xlsx) {
        validateFileUrl(values.xlsx, 'xlsx');
    }

    // Entry form Validation

    if (!values.companyName?.trim()) {
        errors.companyName = "Company name is required.";
    }

    if (!values.vendorSuit?.trim()) {
        errors.vendorSuit = "Vendor suit is required.";
    }

    if (!values.templateId) {
        errors.templateId = "Template must be selected.";
    }


    return errors

}